import handleErrors from '../utils/_handleErrors';
import objectToFormData from '../utils/_objectToFormData';
import getCurrentPageClass from '../utils/_pageClass';
var dyHelpers = require('../utils/_dyHelpers');

class quickView extends HTMLDivElement {
    constructor() {
        super();
        this.currentPageClass = getCurrentPageClass();
        this.sidebar = this.closest('[is="o-sidebar"],[is="o-sidebar-ajax"]');
        // bind this to methods
        this.setSizeListeners = this.setSizeListeners.bind(this);
        this.onSizeSelect = this.onSizeSelect.bind(this);
        this.selectCurrentButton = this.selectCurrentButton.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.fetchProductAction = this.fetchProductAction.bind(this);
        this.loadSize = this.loadSize.bind(this);
        this.onCloseQuickview = this.onCloseQuickview.bind(this);
    }

    connectedCallback() {
        this.initPageType();
        document.addEventListener('click', (e) => {
            const btnTarget = e.target.closest('button');
            if (btnTarget && btnTarget.classList.contains('quick-buy-btn')) {
                const url = btnTarget.dataset.url;
                this.sidebar = this.closest('[is="o-sidebar"]');
                const panelContent = this.sidebar.querySelector('[is="m-quickview"]');
                if (btnTarget.dataset.gtmData) {
                    document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                        detail: {
                            data: JSON.parse(btnTarget.dataset.gtmData),
                            pageType: true
                        }
                    }));
                }

                if (url) {
                    fetch(url, {
                        method: 'GET'
                    }).then((response) => {
                        return response.json();
                    }).then((responseData) => {
                        panelContent.innerHTML = responseData.renderedTemplate;
                        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: responseData.gtmData,
                                eventName: 'quick_view_item',
                                pageType: true
                            }
                        }));
                        this.priceContainer = this.querySelector('.range') || this.querySelector('.prices') || this.querySelector('.price');
                        this.buttonContainer = this.querySelector('.buttons');
                        this.sidebar.onOpenSlidebar();
                        this.loadSize();
                        this.setAddToCartEvent();
                        dyHelpers.setDyRecommendationContext({ type: 'PRODUCT', data: [responseData.product.defaultVariantId] }); // Update SKU for DY recommendations
                    });
                }
            }
        });
        document.addEventListener('oSidebar:close', this.onCloseQuickview);
        this.currentDyData = dyHelpers.setDyRecommendationContext();
    }

    onCloseQuickview(event) {
        if (event && event.detail && event.detail.sidebar === this.sidebar) {
            if (this.currentDyData) { // reset dyData to previous state
                dyHelpers.setDyRecommendationContext(this.currentDyData, true);
            }
        }
    }

    initPageType() {
        if (this.currentPageClass === 'wishlist') {
            this.pageType = 'Wishlist';
        } else if (this.currentPageClass === 'plp') {
            this.pageType = 'Product List Page';
        } else {
            this.pageType = 'Search Bar'; // TODO CHECK With client
        }
    }

    loadSize() {
        let container = this.sidebar.querySelector('.product-sizes-js-load');
        const url = container.dataset.url;

        if (url) {
            fetch(url, { method: 'GET' })
                .then(handleErrors)
                .then((response) => response.text())
                .then((responseText) => {
                    container.innerHTML = responseText;
                    this.setSizeListeners();
                });
        }
    }

    setSizeListeners() {
        var sizeContainerButtons = this.querySelectorAll('.select-size button.size-btn');
        const alreadyActiveButton = this.querySelector('.size-btn[data-selected="true"]');

        for (var button of sizeContainerButtons) {
            if (button.dataset.target !== '#o-sidebar-backinstock') {
                button.addEventListener('click', this.onSizeSelect);
            }
        }

        // if product has unique size, automaticly click on the size element to trigger the update
        if (alreadyActiveButton && !(alreadyActiveButton.hasAttribute('data-target') && alreadyActiveButton.dataset.target === '#o-sidebar-backinstock')) {
            this.currentPid = alreadyActiveButton.dataset.pid;
            alreadyActiveButton.click();
        }
    }

    onSizeSelect(e) {
        this.sidebar.classList.add('loading');
        var currentButton = e.currentTarget;
        const productVariationUrl = currentButton.dataset.url;

        fetch(productVariationUrl)
            .then(handleErrors)
            .then((response) => response.json())
            .then((responseData) => { // eslint-disable-line consistent-return
                if (responseData.gtmData) {
                    if (this.currentPid !== currentButton.dataset.pid) {
                        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: responseData.gtmData,
                                eventName: 'quick_view_item',
                                pageType: true
                            }
                        }));
                    }
                }
                // if product is still available
                if (responseData.product.available === true) {
                    // fetch current product actions
                    const updateActionUrl = responseData.updateActionUrl;
                    // update price in case some size has a different price
                    this.updatePrice(responseData.product.renderedPrice);
                    // set current Button
                    this.selectCurrentButton(currentButton);

                    this.currentPid = currentButton.dataset.pid;

                    dyHelpers.setDyRecommendationContext({ data: [currentButton.dataset.pid] }); // Update SKU for DY recommendations

                    // Update product action buttons
                    return this.fetchProductAction(updateActionUrl);
                }
            })
            .then(() => {
                this.sidebar.classList.remove('loading');
            });
    }

    updatePrice(html) {
        this.priceContainer.innerHTML = html;
    }

    fetchProductAction(updateActionUrl) {
        return fetch(updateActionUrl)
            .then(handleErrors)
            .then((response) => response.text())
            .then((responseActionHtml) => {
                this.querySelector('.buttons').innerHTML = responseActionHtml;
                this.setAddToCartEvent();
            });
    }

    selectCurrentButton(currentButton) {
        var allSizeButtons = this.querySelectorAll('.select-size button');
        for (var button of allSizeButtons) {
            button.setAttribute('data-selected', false);
        }
        currentButton.setAttribute('data-selected', true);
    }

    setAddToCartEvent() {
        const addToCartButton = this.buttonContainer.querySelector('.add-to-cart');

        if (addToCartButton) {
            if (addToCartButton.classList.contains('add-to-cart-no-size-selected')) {
                addToCartButton.addEventListener('click', this.revealSelectSizeError);
            } else {
                const pid = this.buttonContainer.querySelector('.product-id').value;
                const addToCartUrl = this.buttonContainer.querySelector('.add-to-cart-url').value;

                addToCartButton.addEventListener('click', () => { this.addToCart(addToCartUrl, pid); });
            }
        }
    }

    revealSelectSizeError(e) {
        var errorElement = e.currentTarget.parentElement.querySelector('.select-size-error');

        if (errorElement) errorElement.removeAttribute('hidden');
    }

    addToCart(url, pid) {
        const options = { pid: pid, quantity: 1, options: [] };

        return fetch(url, { method: 'POST', body: objectToFormData(options) })
            .then(handleErrors)
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.error) {
                    if (responseJson.hasGiftCardLineItem) {
                        document.querySelector('.custom-error-msg').textContent = responseJson.message;
                    }
                    return;
                }

                document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
                    detail: {
                        productCount: responseJson.quantityTotal
                    }
                }));

                document.dispatchEvent(new CustomEvent('oSidebarAjax:prepareAndSendEvent', { detail: { sidebarId: 'o-sidebar-miniCart' } }));
                
                document.dispatchEvent(new CustomEvent('oSidebar:onCloseSlidebar', { detail: { sidebarId: 'o-sidebar-quickBuy', sidebar: this } }));

                const sidebarActive = document.querySelectorAll('[is="o-sidebar"][aria-expanded="true"], [is="o-sidebar-ajax"][aria-expanded="true"]');
                if (sidebarActive.length <= 1) {
                    const miniCart = document.querySelector('#o-sidebar-miniCart');
                    if (miniCart) {
                        miniCart.classList.remove('another-sidebar-already-active', 'loading');
                    }
                }


                if (responseJson.gtmData) {
                    document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                        detail: {
                            data: responseJson.gtmData,
                            attributes: {
                                add_to_cart_type: this.pageType,
                                page_type: this.pageType
                            }
                        }
                    }));
                }
            });
    }
}

customElements.define('m-quickview', quickView, {
    extends: 'div'
});
